import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IFnsMspRegistry } from '../interfaces/IFnsMspRegistry';

export async function fetchFnsRegistrySearchInn(inn: string): Promise<string | null> {
  return apiGet<string | null>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/fns/registry/inn/${inn}`);
}

export async function fetchFnsRegistrySearchMsp(inn: string): Promise<IFnsMspRegistry | null> {
  return apiGet<IFnsMspRegistry | null>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/fns/registry/msp/${inn}`);
}

export async function fetchFnsRegistrySearchOkved(inn: string): Promise<string[] | null> {
  return apiGet<string[] | null>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/fns/registry/okved/${inn}`);
}
